// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__378zm","name":"styles_name__2zFvB","phone":"styles_phone__8LQnJ"};